// Credit goes to [Underscore.js](http://underscorejs.org/)

/**
 * Returns a function, that, when invoked, will only be triggered at most
 * once during a given window of time. Normally, the throttled function will
 * run as much as it can, without ever going more than once per wait
 * duration; but if you'd like to disable the execution on the leading edge,
 * pass {leading: false}. To disable execution on the trailing edge, ditto.
 */

// throttle's dependent upon _now
_now = Date.now || function() {
	return new Date().getTime();
  };
  
  _throttle = function(func, wait, options) {
	var context, args, result;
	var timeout = null;
	var previous = 0;
	if (!options) options = {};
	var later = function() {
	  previous = options.leading === false ? 0 : _now();
	  timeout = null;
	  result = func.apply(context, args);
	  if (!timeout) context = args = null;
	};
	return function() {
	  var now = _now();
	  if (!previous && options.leading === false) previous = now;
	  var remaining = wait - (now - previous);
	  context = this;
	  args = arguments;
	  if (remaining <= 0 || remaining > wait) {
		if (timeout) {
		  clearTimeout(timeout);
		  timeout = null;
		}
		previous = now;
		result = func.apply(context, args);
		if (!timeout) context = args = null;
	  } else if (!timeout && options.trailing !== false) {
		timeout = setTimeout(later, remaining);
	  }
	  return result;
	};
  };
  
  $(document).ready(function() {
	  $(".comment-form textarea, .comment-form input[type='text'], .comment-form input[type='email'], .comment-form input[type='url']").each(function() {
		  $(this).parent().addClass("input-wrap");
		  var label = $(this).parent().find("label").text();
		  if (label) $(this).attr("placeholder", label);
	  });
	  
	  $(".post-tags a").each(function() {
		  $(this).addClass("ribbon-btn");
		  var label = $(this).text();
		  $(this).html('<span class="label">'+label+'</span><div class="hover"><div class="ls"></div><div class="rs"></div></div>');
	  });
	  
	  $(".comments-collapse").slideUp(0);
	  $(".add-comment-btn").on("click", function(e) {
		  e.preventDefault();
		  $(".comments-collapse").slideDown();
		  var top = $(".comment-respond").offset().top-100;
		  $('html, body').stop(true).animate({scrollTop:top}, 500, "easeInOutQuad");
	  });
  
  });
  //  variables in the global scope
  var desktopSearchPlaceholder;
  var time = 0;
  var isfirstload = 1;
  var hazfullpage = 0;
  var scrollHandlerMoocho;
  var mql = matchMedia("screen and (max-width: 769px)"); // whatever your MQ should be e.g. (min-width: 40em)
  
  
  
  
  if (!Array.prototype.includes) {
	Object.defineProperty(Array.prototype, "includes", {
	  enumerable: false,
	  value: function(obj) {
		  var newArr = this.filter(function(el) {
			return el == obj;
		  });
		  return newArr.length > 0;
		}
	});
  }
  
  
  
  Array.prototype.diff = function(arr2) {
	  if (arr2 instanceof Array && this instanceof Array) {
		  var ret = [];
		  for (var i in this) {
			  if (arr2.indexOf(this[i]) > -1) {
				  ret.push(this[i]);
			  }
		  }
		  return ret;
  
	  } else {
		  return new Array();
	  }
  };
  $.fn.queueAddClass = function(className) {
	  this.queue('fx', function(next) {
		  $(this).addClass(className);
		  next();
	  });
	  return this;
  };
  $.fn.queueRemoveClass = function(className) {
	  this.queue('fx', function(next) {
		  $(this).removeClass(className);
		  next();
	  });
	  return this;
  };
  
  
  function setCookie(name,value,days) {
	  var expires = "";
	  if (days) {
		  var date = new Date();
		  date.setTime(date.getTime() + (days*24*60*60*1000));
		  expires = "; expires=" + date.toUTCString();
	  }
	  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }
  function getCookie(name) {
	  var nameEQ = name + "=";
	  var ca = document.cookie.split(';');
	  for(var i=0;i < ca.length;i++) {
		  var c = ca[i];
		  while (c.charAt(0)==' ') c = c.substring(1,c.length);
		  if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	  }
	  return null;
  }
  function eraseCookie(name) {
	  document.cookie = name+'=; Max-Age=-99999999;';
  }
  
  //use fullpagejs ?
  var useFullPage = function() {
	  var templateName = $('.barba-container').data('namespace');
	  bodyColor();
	  throttle();
	  //moocho scroll handler
	  // $(window).unbind("scroll", scrollHandlerMoocho);
  
	  var noFullpageTemplateList = ["front-page","get_reviews_all_products","get_reviews","creator","food-service-videos","food-services-new","holiday-no-nav","campaign-no-nav", "food-service-form", "pw-page", 404, "archive-product", "taxonomy-product_cat", "cart", "trot-faqs", "single-product", "product", "single-recipe", "contact-us", "contact", "blank", "white-bg-secondary-page", "color-bg-secondary-page", "media-resources", "trot-signup", "search", "careers-page"];
	  console.dir('templateName:' + templateName);
	  if(jQuery.inArray(templateName, noFullpageTemplateList) == -1){
		  //use fullpage
		  hazfullpage = 1;
		  //turn off fullpage for media resources mobile
		  if($('body').hasClass('mobile') && $('body').hasClass('password_required')) {
		   hazfullpage = 0;
		  }
		  //turn off fullpage for woocommerce pages
		  if($('body').hasClass('woocommerce-page')  || $('body').hasClass('woocommerce-cart') ) {
		   hazfullpage = 0;
		  }
  
  
	  }else{
		  //no fullpage
		   hazfullpage = 0;
	  }
  
	  if(hazfullpage == 1){
		  //console.dir('use fullpage');
  
		  //console.dir($('div').find('#section0'));
  
  
  
  
		  if ($('html').hasClass('fp-enabled')) {
  
			  fullpage_api.destroy('all');
		  }
  
		  fullpageInit(templateName);
  
  
  
	  }else{
  
		  console.dir('nofullpage');
		  //templates that don't use fullpage.js
		  if ($('html').hasClass('fp-enabled')) {
  
			  fullpage_api.destroy('all');
		  }
		  //setupHeadroom(mql);
		  //useHeadroomJS();
		  //mql.removeListener(setupHeadroom);
  
		  mql.addListener(setupHeadroom); //listen for future changes
		  setupHeadroom(mql); // handle for page load
  
		  navAnimation();
  
		  updateNav();
		  throttle();
		   clearTimeout($.data(this, 'scrollTimer'));
  
			  //appear.js -- use this for pages not using fullpage.js
			   appear({
					init: function init(){
  
					},
					elements: function elements(){
					  // work with all elements with the class "track"
					  return document.querySelectorAll('.appear,.animateFade')
					},
					appear: function appear(el){
  
					//illustration animation
					 if( $( el ).hasClass('illustration')) {
							 var $img = $( el ).find('img');
						  $img.delay(0).queueAddClass('slide-in-bottom');
					  }
  
					  					//run animatefade
					  if( $( el ).hasClass('animateFade')) {
  
						if ($(el).hasClass('animateDelay2')) {

							animateFade($(el), 2000, 200);
						} else if ($(el).hasClass('animateDelay')) {
							animateFade($(el), 1300, 200);
						} else {
							animateFade($(el), 200, 200);
						} 
  
					}
				  }, 
				  disappear: function disappear(el){
					 // console.log('no longer visible', el);
				  },
				  bounds: 0,
				  reappear: true
				});
			  //end appear.js
  
  
			  //page specific js
  
			  
	  //make sure barba-container is inside fullpage
	  var barbaContainerInside = $('#fullpage .barba-container').length;
	  //console.dir('barbaContainerInside:' + barbaContainerInside);
  
	  if(! barbaContainerInside) {
		  $('.barba-container').prependTo("#fullpage");
  
	  }
  
  
		  if(templateName == 'product') {
			  productPageJS();
		  }else{
				$('html,body').animate({scrollTop:0},0);
			   // moochoPromoHide('slide-out-hidden');
		  }
  
  
	  };
  
	  if(templateName == 'search') {
		  searchPageJS();
	  }
  
	  if(templateName == 'food-services') {
		  foodServicesPageJS();
	  }
  
	  if(templateName == 'food-services-new') {
		  foodServicesPageJS();
	  }
  
	  if(templateName == 'category-recipes') {
		  recipeLandingPageJS();
	  }
  
	  if(templateName == 'get_reviews') {
		  getReviewsPageJS();
	  }

	  if(templateName == 'creator') {
		creatorPageJS();
	}
  
  };
  
  
  
  
  //fullpage
  
  
  var fullpageInit = function(templateName) {
  
				  //make sure barba-container is inside fullpage
				  var barbaContainerInside = $('#fullpage .barba-container').length;
  
				  if(! barbaContainerInside) {
					  $('.barba-container').prependTo("#fullpage");
  
				  }
  
  
  
  
					var myFullpage = new fullpage('#fullpage', {
			  autoScrolling:false,
									   scrollOverflow: false,
  
										  scrollBar: true,
							  fitToSection: false,
										  fitToSectionDelay: 0,
									  scrollOverflowReset: false,
									  licenseKey: 'D994834A-ADD34375-85D25459-3C4EB4CA',
									  lazyLoading: false,
									  fixedElements: '.navbar',
									  recordHistory: false,
									//  css3: true,
									  keyboardScrolling: false,
									  navigation: false,
									  responsiveHeight: 415,
  
  
						  afterRender: function(){
							  //console.dir('afterRender');
								  //todo -- make sure elements are defined before init-ing them....and fix pdp slider issue
  
								  //page loaded and fullpage is ready.  Now bring in top elements
  
								  //init slider
								  homesliders();
  
								  if(templateName == 'front-page'){
								  //	moochoPromoShow();
								  }else{
  
								  //	moochoPromoHide('slide-out-hidden');
  
								  };
  
								  //nav animation
  
  
									  navAnimation();
  
								  //nav condensed or not?
								  updateNav();
  
								  //trot functions
								  trotPage();
  
  
								  //preload any animated images that fade/slide
								  $('.section img').addClass('lazypreload');
  
							  },
  
						   onLeave: function(origin, destination, direction){
  
  
							  var currentSlide = origin.item;
							  var nextSlide = destination.item;
							  var $this = $(nextSlide);
  
							  //pin-unpin mobile nav
							  useHeadroomJS(direction);
  
							  if(templateName == 'front-page'){
								  // moochoPromoHide();
								  // moochoPromoShow('quick');
							  }
  
							  //now run a function to get current color and crossfade bg color of next slide
							  getColorTransition(currentSlide,nextSlide);
  
							  //if we aren't on the top/first slide, then condense top nav
							  navScroll(nextSlide.id);
  
							  //   updateNav();
							  // if($thisNextSlide.hasClass('hidden')){
							  // 	$thisNextSlide.removeClass('hidden');
							  // }
  
  
							  //homepage product cat slider animations
							  if($this.hasClass('product-category-slider')){
  
								  var $h2 = $this.find('h2');
  
								  var $product_badge = $this.find('.prod-slider-badge');
								  var $subtitle = $this.find('.subtitle');
  
								  $product_badge.delay(400).queueAddClass('fadein');
								  $h2.delay(600).queueAddClass('fadein');
								  $subtitle.delay(800).queueAddClass('fadein');
  
								  $(".product-category-slider .slick-slide").each(function(index){
  
									  var stallFor = 100 * parseInt(index);
									   $(this).delay(stallFor).queueAddClass('fadein');
  
								  })
  
								  $(".product-category-slider .slick-arrow").delay(1000).queueAddClass('fadein');
  
  
							  }
							  // end cat slider animations
  
							  //section illustrations (section 2 etc)
							  if($this.hasClass('illustration')){
								  var $img = $this.find('img');
								  $img.delay(0).queueAddClass('slide-in-bottom');
  
							  }
							  //end illustrations
  
								  // content slider section 3
							  if($this.hasClass('the-content-slider')){
  
  
  
									  var thisID = $this.attr('id');
									  var carouselID = $('#'+ thisID + ' .carousel').attr('id');
  
  
								  //get id
								  if( carouselID == 'home-content-slider') {
									  window.home_content_slider.flickity('playPlayer');
									  var $first_content_slide = $('#home-content-slider .carousel-cell.is-selected');
									  animateSlideContent_home_content_slider($first_content_slide,time);
								  }
								  if( carouselID == 'home-content-slider-left'){
									  window.home_content_slider_left.flickity('playPlayer');
									  var $first_content_slide = $('#home-content-slider-left .carousel-cell.is-selected');
									  animateSlideContent_home_content_slider($first_content_slide,time);
								  }
							  }
							  //end prod content slider
  
							  // content slider section 5
							  if($this.hasClass('the-content-slider-center')){
								  window.home_content_slider_center.flickity('playPlayer');
								  var $first_content_slide_center = $('#home-content-slider-center .carousel-cell.is-selected');
								  animateSlideContent_home_content_slider($first_content_slide_center,time);
							  }
							  //end prod content slider
  
							  //  slider image center
							  if($this.hasClass('image_slider_2')){
								  window.home_content_slider_center_2.flickity('playPlayer');
								  var $first_content_slide_center_2 = $('#home-content-slider-center-2 .carousel-cell.is-selected');
								  animateSlideContent_home_content_slider($first_content_slide_center_2,time);
							  }
							  //end prod content slider
  
							  //  slider image center 1
							  if($this.hasClass('image_slider_1')){
								  window.home_content_slider_center_1.flickity('playPlayer');
								  var $first_content_slide_center_1 = $('#home-content-slider-center-1 .carousel-cell.is-selected');
								  animateSlideContent_home_content_slider($first_content_slide_center_1,time);
							  }
							  //end prod content slider
  
  
							  if($this.hasClass('promo-block-home')){
								  var thisID = $this.attr('id');
								  var $this_container = $('#'+thisID);
  
								  animateFade($this_container);
  
							  }
  
							  if($this.hasClass('three-rows-home')){
									  //fullpage_api.reBuild();
								  var $this_container = $('.three-rows-home');
								   animateFade($this_container);
  
								   window.home_mobile_only_slider.flickity('playPlayer');
  
							  }
  
							  if($this.hasClass('animate-section')){
									  //fullpage_api.reBuild();
								  var thisID = $this.attr('id');
								  var $this_container = $('#'+thisID);
								   animateFade($this_container);
  
							  }
  
  
						  },
  
						  afterLoad: function(origin, destination, direction){
  
							  //content animations after slide
							  var currentSlide = destination.item;
							  var $this = $(currentSlide);
  
  
						  },
  
					  });
  
			  isfirstload = 0;
		  }
  
  
	  var getColorTransition = function(currentSlide,nextSlide) {
				  var colors = ["red", "green", "blue", "orange", "white", "limegreen", "brown", "blue-green"];
  
				  var  currentSlideClassesArray = Array.from(currentSlide.classList);
				  var  nextSlideClassesArray = Array.from(nextSlide.classList);
				  var classTransitionList = "brown_to_brown red_to_red green_to_blue blue_to_green white_to_green green_to_white green_to_green blue_to_blue red_to_blue blue_to_red green_to_red red_to_green orange_to_blue blue_to_orange orange_to_orange red_to_orange orange_to_red limegreen_to_orange orange_to_limegreen limegreen_to_limegreen orange_to_brown brown_to_orange blue_to_blue-green blue-green_to_blue";
				  //get current bg color of block:
				   var currentColor = colors.diff(currentSlideClassesArray)[0];
				   var nextColor = colors.diff(nextSlideClassesArray)[0];
  
				   //combine the 2 colors and add that class to the next block
				   // console.dir(currentColor);
				   // console.dir(nextColor);
				   if (currentColor != undefined && nextColor != undefined ) {
  
					   var nextBlockClass = currentColor + "_to_" + nextColor;
					   $('body').removeClass(classTransitionList);
					  $('body').addClass(nextBlockClass);
  
					   $('body').addClass(nextColor);
						   if(nextColor != currentColor) {
							   $('body').removeClass(currentColor);
						   }
				   }
  
  
  
  
  
  
  
			  }
  
  
			  var navScroll = function(sectionID) {
				  if(sectionID != 'section0') {
					  $('.navbar-fixed-top').addClass("condensed");
				  }else{
					  $('.navbar-fixed-top').removeClass("condensed");
				  }
			  }
  
  
  
  
  //animations
  var animateFade = function(container, delay, step) {
	  var $this = container;
	  console.dir('animate fade called:');
	 // console.dir( $this);
	  delay = typeof delay !== 'undefined' ? delay : 200;
	  step = typeof step !== 'undefined' ? step : 200;
	  //sort by data-animatefade value
	  var sortedElementsToAnimate = $this.find('*[data-animatefade]').sort(function(a, b) {
		  return +a.dataset.animatefade - +b.dataset.animatefade;
	  })
  //console.dir( 'delay:' + delay);
  
	  var delay = delay;
	  var step = step;
	  var stepCounter = step;
	  setTimeout(function() {
  
		  sortedElementsToAnimate.each(function(i) {
			  //fadeOrder = $(this).data("animatefade");
  
			  $(this).delay(stepCounter).queueAddClass('fadein');
			  stepCounter += step;
		  });
	  }, delay);
  };
  
  
  var animateSlideContent_home_content_slider = function(slider, time) {
	  // var currentSlideIndex = slider.selectedIndex;
  
  
	  var currentSlideObj = slider.selectedElement;
	  if (currentSlideObj) {
		  //console.dir(currentSlideObj);
	  } else {
		  //init slider - first slide
		  var currentSlideObj = slider;
		  //	console.dir(currentSlideObj);
		  time = 0;
	  }
  
  
  
	  var $this = $(currentSlideObj);
  
	  animateFade($this, time, 250);
  
  };
  
  
  var animateSlideContent = function(slider, time) {
  
	  // var currentSlideIndex = slider.selectedIndex;
  
  
	  var currentSlideObj = slider.selectedElement;
	  var $this = $(currentSlideObj);
	  animateFade($this, time, 250);
  
  };
  
  var navAnimation = function(){
	  //console.dir('navAnimation'); 
	  //slide in logo block, top menu animations
	  $('.navbar-header').delay(650).queueAddClass('slideDown');
	  $('.navbar-nav.navbar-right > li:nth-of-type(1) > a').delay(1100).queueAddClass('fadein');
	  $('.navbar-nav.navbar-right > li:nth-of-type(2) > a').delay(1250).queueAddClass('fadein');
	  $('.navbar-nav.navbar-right > li:nth-of-type(3) > a').delay(1400).queueAddClass('fadein');
	  $('.navbar-nav.navbar-right > li:nth-of-type(4) > a').delay(1650).queueAddClass('fadein');
	  $('.navbar-nav.navbar-right > li:nth-of-type(5) > a').delay(1800).queueAddClass('fadein');
	  $('.navbar-nav.navbar-right > li:nth-of-type(6) > a').delay(1800).queueAddClass('fadein');
	  $('.top-utility-nav').delay(1900).queueAddClass('fadein');
	  $('.navbar-default .divider').delay(2000).queueAddClass('fadein');
	  $('.navbar-default').delay(2100).queueAddClass('nav-in');
  }
  
  var navAnimationReset = function(){
	  //console.dir('navAnimationReset');
	  //slide in logo block, top menu animations
	  $('.navbar-header').removeClass('slideDown');
	  $('.navbar-nav.navbar-right > li:nth-of-type(1) > a').removeClass('fadein');
	  $('.navbar-nav.navbar-right > li:nth-of-type(2) > a').removeClass('fadein');
	  $('.navbar-nav.navbar-right > li:nth-of-type(3) > a').removeClass('fadein');
	  $('.navbar-nav.navbar-right > li:nth-of-type(4) > a').removeClass('fadein');
	  $('.navbar-nav.navbar-right > li:nth-of-type(5) > a').removeClass('fadein');
	  $('.navbar-nav.navbar-right > li:nth-of-type(6) > a').removeClass('fadein');
	  $('.top-utility-nav').removeClass('fadein');
	  $('.navbar-default .divider').removeClass('fadein');
  }
  //end animations
  
  
  
  //search js
  var searchPageJS = function() {
   $(document).ready(function(){
		  // doesn't work well for iPad, background didn't fill in behind nav until user stops scrolling, I think it's a battery performance "feature" of iOS:
		  var mobile = (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
		  if ($(window).width() > 1024 && !mobile) {
		  $("#search-subnav-wrapper").sticky({topSpacing:76, className:"stuck", wrapperClassName:"sticky-wrapper"});
  
		   //scrollto
	  $('a.subnav-link').on('click',function (e) {
		  //console.dir('scrollto');
		  e.preventDefault();
  
		  var target = this.hash;
		  var $target = $(target);
		  if ($target.length < 1) return;
  
		  $('html, body').stop().animate({
			  'scrollTop': $target.offset().top  - 160
		  }, 400, 'swing', function () {
			  window.location.hash = target;
		  });
	  });
  
		  }
	  });
  }


  var creatorPageJS = function() {
	(function() {
		console.log('creatorPageJS');
	  var desktopWidth = 798;
	
	  function setCollapseState() {
		var $panels  = $('#creator_accordion .collapse');
		var $buttons = $('#creator_accordion [data-toggle="collapse"], #creator_accordion .faq-button');
	
		if (window.innerWidth >= desktopWidth) {
		  $panels.collapse('show');
		  $buttons.removeClass('collapsed').attr('aria-expanded', 'true');
		} else {
		  $panels.collapse('hide');
		  $buttons.addClass('collapsed').attr('aria-expanded', 'false');
		}
	  }
	
	  // 1) On DOM ready, _immediately_ collapse everything if we're on mobile
	  $(function() {
		if (window.innerWidth < desktopWidth) {
		  var $panels  = $('#creator_accordion .collapse');
		  var $buttons = $('#creator_accordion [data-toggle="collapse"], #creator_accordion .faq-button');
		  // remove any "in"/show class, then hide
		  $panels.removeClass('in show').collapse('hide');
		  // ensure toggles are marked collapsed
		  $buttons.addClass('collapsed').attr('aria-expanded', 'false');
		}
	  });
	
	  // 2) One‐time scroll trigger
	  function onFirstScroll() {
		setCollapseState();
		window.removeEventListener('scroll', onFirstScroll);
	  }
	  window.addEventListener('scroll', onFirstScroll, { passive: true });
	
	  // 3) Always keep resize handler active
	  $(window).on('resize', setCollapseState);
	
	  // 4) Delegate click toggles
	  $('#creator_accordion').on('click', '.collapse-toggle, .faq-button', function(e) {
		e.preventDefault();
		var target    = $(this).data('target') || $(this).attr('href'),
			$panel    = $(target),
			$triggers = $('#creator_accordion')
						  .find('[data-target="' + target + '"], [href="' + target + '"]');
	
		$panel.collapse('toggle');
		var wasExpanded = $(this).attr('aria-expanded') === 'true';
		$triggers
		  .toggleClass('collapsed', wasExpanded)
		  .attr('aria-expanded', String(!wasExpanded));
	  });
	
	  // 5) Keep aria & classes in sync if collapse is triggered elsewhere
	  $('#creator_accordion .collapse')
		.on('shown.bs.collapse hidden.bs.collapse', function() {
		  var isOpen   = $(this).hasClass('show') || $(this).hasClass('in'),
			  sel      = '[data-target="#' + this.id + '"], [href="#' + this.id + '"]';
		  $('#creator_accordion').find(sel)
			.toggleClass('collapsed', !isOpen)
			.attr('aria-expanded', String(isOpen));
		});
	})();
	
	 
	
		function scrollToAnchor(aid){
			var aTag = $("a[name='"+ aid +"']");
			$('html,body').animate({scrollTop: aTag.offset().top-150},'slow');
		}
		
		$("#apply").click(function() {
		   scrollToAnchor('apply');
		});
		$("#apply1").click(function() {
		   scrollToAnchor('apply');
		});
	
	}
  
  
  var getReviewsPageJS = function() {
  
	  function scrollToAnchor(aid){
		  var aTag = $("a[name='"+ aid +"']");
		  $('html,body').animate({scrollTop: aTag.offset().top-150},'slow');
	  }
	  
	  $("#prod-review-slider").click(function() {
		 scrollToAnchor('prod-review-slider');
	  });
  
	   
  
  
		//prod category slider
		var $productsliderhome = $('.product-slider-home');
  
		if ($productsliderhome.length) {
	  var $slider = $('.product-slider-home')
  
				 .on('init', function(slick) {
					//$('.product-slider-home').fadeTo(1);
					 $('.product-slider-home').css('visibility','visible').hide().fadeIn();
  
  
				})
  
  
				.slick({
					dots: false,
					infinite: false,
					speed: 400,
					slidesToShow: 3,
					slidesToScroll: 1,
					lazyLoad: false,
  
					easing: 'easeInOutBack',
					useTransform: true,
					dots: false,
					responsive: [
					{
					breakpoint: 1024,
					settings: {
					slidesToShow: 3
  
					}
					},
					{
					breakpoint: 768,
					settings: {
					slidesToShow: 2
					}
					},
					{
					breakpoint: 520,
					settings: {
					slidesToShow: 1
					}
					}
  
					]
  
				})
  
			   }
			   //end prod cat slider
  
  }
  
  
  
  var foodServicesPageJS = function() {
  
  
	  
  
  
	  function scrollToAnchor(aid){
		  var aTag = $("a[name='"+ aid +"']");
		  $('html,body').animate({scrollTop: aTag.offset().top-150},'slow');
	  }
	  
	  $("#products-link").click(function() {
		 scrollToAnchor('products');
	  });
	  $("#recipes-link").click(function() {
		  scrollToAnchor('recipes');
	   });
	   $("#faqs-link").click(function() {
		  scrollToAnchor('faqs');
	   });
	   $("#dist-link").click(function() {
		  scrollToAnchor('dist');
	   });
	   $("#samples-link").click(function() {
		  scrollToAnchor('samples');
	   });
	   
  
  
  
  
	   if(window.location.hash) {
		  var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
		  if(hash = 'get-samples') {
  
			  setTimeout(GetSamplesScroll,2000);
  
  
	  //	scrollToAnchor('samples');
		  }
		  // hash found
	  } else {
		  // No hash found
	  }
  
  
  function GetSamplesScroll() {
	  scrollToAnchor('samples');
	  // $('#form').addClass('in');
	  // $("#samples-btn").removeClass('collapsed')	 
	  $('#form').collapse('show');
   }
  
   if(	$("#samples-btn").hasClass('collapsed')	) {
	  $(this).find('.btn-text').html('Request Samples');
	  $(this).find('.btn-text-show').html('Request Samples');
  }else{
	  $(this).find('.btn-text').html('Hide Form');
	  $(this).find('.btn-text-show').html('Hide Form');
  }
  
  
  
	$('#form').on('shown.bs.collapse', function () {
	  $("#samples-btn").find('.btn-text').html('Hide Form');
	  $("#samples-btn").find('.btn-text-show').html('Hide Form');
	})
  
	$('#form').on('hidden.bs.collapse', function () {
	  $("#samples-btn").find('.btn-text').html('Request Samples');
	  $("#samples-btn").find('.btn-text-show').html('Request Samples');
	})
  
  
  
	  if ($(window).height() > 500) {
  
  
  
  
		  $(".sticky-sub-nav").sticky({topSpacing:0, className:"stuck"});
  
	  }
  
  
	  var $foodservice_slider =  $('.recipe-carousel-new').flickity({
		  // options
		lazyLoad: false,
  
		wrapAround: true,
		 dragThreshold: 10,
		 adaptiveHeight: true,
		 pageDots: false,
		 imagesLoaded: true
  
  
		});
  
  
		$( "#prod-container" ).insertAfter( "div.grid-block:eq(1)" );
			   $( "#recipe-block" ).insertAfter( "div.grid-block:eq(3)" );
  
			 $("#prod-container [data-href]").click(function() {
				$theHref = $(this).attr("data-href");
				 //window.location.href = $theHref;
				 window.open(
				   $theHref,
					'_blank' // <- This is what makes it open in a new window.
				  );
			 });
  
  
  
				var mobile = (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
	  //        if ($(window).width() > 1024 && !mobile) {
	  //            $(".prod-cat-subnav").sticky({topSpacing:60, className:"stuck"});
	  //        }
  
		  //   $(".prod-cat-subnav > a").on('click', function () {
		  //       //wait for hash change
  
  
		  //          setTimeout(function() {
		  //             showProducts();
		  //         }, 300);
		  //     });
  
  
  
			showProducts = function(){
				 var hash = window.location.hash.substr(1);
					if(hash == ''){
						hash = 'deli-slices-food-service';
					}
  
  
  
			   // $('#loadingImg').fadeIn('fast');
  
  
  
				  var jqxhr = $.ajax({
					  url: document.location.origin + '/food-service/' + hash,
					  // dataType: 'html',
					  // success: function(html) {
					  //     console.dir(html);
  
  
					  //       $( "#products-loader > div" ).fadeOut( "fast", function() {
					  //         console.dir('fadeout');
					  //         $("#products-loader").html('');
					  //         console.dir('cleared');
					  //         $("#products-loader").append( html );
					  //      $('#loadingImg').fadeOut('fast');
					  //       });
  
					  // }
				  });
  
				   jqxhr.done(function( html ) {
					$( "#products-loader > div" ).fadeOut( "fast");
					$("#products-loader").html('');
				  //  $('#loadingImg').fadeOut('fast');
				  //  $( "#products-loader > div" ).fadeOut( "fast", function() {
					  $("#products-loader").append( html );
					//  });
				  });
  
  
				   // $("#products-loader").load('<?php get_site_url() ?>/food-service/' + hash, function(response, status, xhr) {
				   //    console.dir('hash: ' + hash);
				   //     console.dir(response);
				   //       console.dir(status);
				   //      $('#loadingImg').fadeOut('fast');
				   //  });
  
				//highlight proper link in subnav
				$('.prod-cat-subnav .food-service-subnav').removeClass('current-page');
				$thisNavItem = $('.prod-cat-subnav').find("[data-id='" + hash + "']");
  
				  if($thisNavItem){
					  $thisNavItem.addClass('current-page');
				  }
  
			}
  
			 showProducts();
  
  }
  
  //recipe landing page js
  var recipeLandingPageJS = function() {
  
	  //console.dir('recipeLandingPageJS');
  
	  if($('#recipeSection4').length) {
		  $('#recipe_illustration_block').addClass('show-section');
		  $('#recipe_illustration_block').insertBefore('#recipeSection4')
	  }else{
		  $('#recipe_illustration_block').remove();
	  }
	   fullpage_api.reBuild();
		  $( ".recipe-block:odd" ).addClass( "recipe-odd" );
		$( ".recipe-block:even" ).addClass( "recipe-even" );
	   // setTimeout(function(){
	   // 	console.dir($( ".recipe-block:odd" ));
  
	//   }, 1000);
  
  
  
	   if($('body.paged').length) {
		   setTimeout(delayedAnimation, 800);
		   function delayedAnimation() {
			 //do whatever you want here
			 fullpage_api.moveTo(2);
		  }
	  }
  
  }
  
  
  
  //product page js
  var productPageJS = function() {
  
		  $(document).ready(function(){
  
  
		 // Function to load the external BV script dynamically if not already loaded
		 function loadBVScript(callback) {
		  if (typeof BV !== 'undefined') {
			console.log('BV is already loaded.');
			if (callback) callback();
		  } else {
			var script = document.createElement('script');
			script.type = 'text/javascript';
			script.async = true;
			script.src = 'https://apps.bazaarvoice.com/deployments/tofurky/main_site/production/en_US/bv.js'; 
			script.onload = function() {
			  console.log('BV script loaded.');
			  if (callback) callback();
			};
			script.onerror = function() {
			  console.error('Failed to load BV script.');
			};
			document.head.appendChild(script);
		  }
		}
	
		// Click handler function for conversion tracking
		function clickHandler(event) {
		  console.log('Button clicked');
		  if (typeof BV !== 'undefined') {
			console.log('trackConversion');
			BV.pixel.trackConversion({
			  "type": "StoreLocator",
			  "label": "StoreLocator_ProductPage",
			  "value": "value"
			});
		  } else {
			console.warn('BV is not defined');
		  }
		}
	
		// Initialize reviews by attaching event listeners to buttons
		function initReviews() {
		  console.log('initReviews called');
		  var buttons = document.querySelectorAll('.find-store-btn');
		  if (buttons.length === 0) {
			console.warn('No buttons found for selector ".find-store-btn"');
		  } else {
			console.log(buttons.length + ' button(s) found');
		  }
		  // Remove previous listeners to avoid duplicates and then attach the new listener
		  buttons.forEach(function(button) {
			button.removeEventListener('click', clickHandler);
			button.addEventListener('click', clickHandler);
		  });
		}
	
		// Load the BV script (if needed) then initialize reviews
		loadBVScript(function() {
		  initReviews();
		});
	
  
	  
  
		  //	moochoPromoShow('quick','product_page');
			  //console.dir('product page js ran');
  
  
  
		 //  	$(window).scroll(function() {
		 //  		   clearTimeout($.data(this, 'scrollTimer'));
			   // //   moochoPromoHide();
		 //
			   //    $.data(this, 'scrollTimer', setTimeout(function() {
			   //        // do something
			   //       //console.log("Haven't scrolled in 1050ms!");
			   //        moochoPromoShow('nodelay','product_page');
		 //
			   //    }, 1050));
		 //  	});
  
  
  
  
  
  
			  //	$(window).scroll(scrollHandler);
  
  
			   //adjust title illustrations
			  textWidth = $(".icon-title h2").width();
			  imageWidth = $(".prod-title-img").attr("width");
  
			  if(imageWidth > textWidth){
				  adjustPixels = imageWidth - textWidth;
				  adjustPixels = "-"+adjustPixels+"px";
  
				  $(".prod-icon-title").css("right", adjustPixels)
			  }
  
			   //count slides
				var break_1_show = 4;
				var break_2_show = 3;
				var total_slides = $('.flavor-slider > div').length;
  
  
				if (total_slides >= 4){
					 break_1_show = 4;
					 break_2_show = 3;
				};
				if (total_slides == 3){
					 break_1_show = 3;
					 break_2_show = 3;
				};
				 if (total_slides == 2){
					 break_1_show = 2;
					 break_2_show = 2;
				};
  
				 if (total_slides < 2){
					 break_1_show = 1;
					 break_2_show = 1;
				};
  
  
			  //slider script
			  var $slider = $('.flavor-slider').on('init', function(slick) {
				  $('.flavor-slider-container').fadeIn();
			  })
  
  
  
  
			 .slick({
  
				   centerMode: false,
				 // centerPadding: '60px',
				  infinite: false,
				  speed: 400,
				  slidesToShow: 5,
				  slidesToScroll: 1,
				  lazyLoad: true,
				  variableWidth: false,
				  easing: 'easeInOutBack',
				  useTransform: true,
				  dots: false,
				  responsive: [
				  {
				  breakpoint: 1024,
				  settings: {
				  slidesToShow: break_1_show
  
  
				  }
				  },
				  {
				  breakpoint: 768,
				  settings: {
				  slidesToShow: break_2_show
  
				  }
				  },
				  {
				  breakpoint: 520,
				  settings: {
				  slidesToShow: 1
  
				  }
				  }
  
				  ]
  
			  });
  
			  var page_index = $('.flavor-slider').find('a.current-page').parent().index();
  
			  $slider.slick('slickGoTo',page_index,false);
  
			  // doesn't work well for iPad, background didn't fill in behind nav until user stops scrolling, I think it's a battery performance "feature" of iOS:
			//  var mobile = (/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
			  //&& !mobile
			 // if ($(window).width() > 100) {
  
  //             document.addEventListener("touchmove", ScrollStart, false);
  //            document.addEventListener("touchend", ScrollEnd, false);
  
			   var theHash =  window.location.hash;
  
  
  
			  if ($(window).height() > 500) {
  
  
  
  
				  $(".flavor-nav").sticky({topSpacing:0, className:"stuck"});
  
				  if(theHash == '#flavormenu') {
					  if(! $('.sticky-wrapper').hasClass('stuck')){
						   $('.sticky-wrapper').addClass('stuck');
						   $('.row.flavor-nav').addClass('stuck');
					  }
  
						if ($(window).width() > 769) {
							var offset_top = 350;
							 }else if ($(window).width() < 769 &&  $(window).width() > 521){
								 var offset_top = 300;
							 }else{
							  var offset_top = 250;
						}
						//console.dir(offset_top);
							$('html, body').animate({
								  scrollTop: $(".prod-body").offset().top-offset_top
							  }, 300);
							 $('html, body').animate({
								  scrollTop: $(".prod-body").offset().top-offset_top+1
							  }, 300);
  
  
					  }
			  }
  
  
			  if(theHash != '#flavormenu') {
				  $('html,body').animate({scrollTop:0},0);
			  }
  
  
  
  
  
  
  
  
			  var $pdp_slider =  $('.product-slider .carousel').flickity({
			  // options
			lazyLoad: false,
  
			 prevNextButtons: false,
			 dragThreshold: 10,
					  autoPlay: false,
					  wrapAround: true
  
  
			});
  
  
		  });
  }
  
  var timerCheckCooke;
  
  // $(document).on("cmplzEnableScripts", myScriptHandler);
  // function myScriptHandler(consentData) {
  // 	//console.log(consentData.consentLevel);
  // 	//add check timer to see when checked
  // 	if (!timerCheckCooke) {
  // 		var timerCheckCooke = setInterval(checkCookie, 1500);
  // 	}
  // 	function checkCookie() {
  // 	    var myCookie = getCookie("complianz_consent_status");
  // 	    console.dir(myCookie);
  // 	    if (myCookie != null) {
  // 	        moochoPromoShow('quick');
  // 	        clearInterval(timerCheckCooke);
  // 	         timerCheckCooke = null;
  // 	    }
  // 	}
  //
  // }
  
  // var moocho_timer;
  // function moochoPromoShow(speed,page) {
  // 	//moochoPromoHide();
  // 	console.dir('show moocho');
  //   window.clearTimeout(moocho_timer);
  //   //var millisecBeforeRedirect = 10000;
  //   if(speed == 'quick') {
  //   	var time = 1500;
  //   }else if(speed == 'menu'){
  //   	var time = 200;
  //   }else if(speed == 'nodelay'){
  //   	var time = 0;
  //   }else{
  //   		var time = 3000;
  //   }
  //  // console.dir('showing moocho - page:' + page);
  //    var $is_open = $('#moocho-container').hasClass('slide-in-bottom');
  //    //console.dir('isopen: ' + $is_open);
  //    if(! $is_open) {
  //   		moocho_timer = window.setTimeout(function(){moochoPromoShowTimer();},time);
  // 	}
  // }
  
  //moocho promo
  // var moochoPromoShowTimer = function() {
  //
  // 			  var $moocho_container = $('#moocho-container');
  //
  // 			  if ($moocho_container.length) {
  //
  // 			  	var show_moochopromo = true;
  // 			  	var moocho_cookie_value = getCookie('moocho_cookie_new_9');
  // 			  //	var complianz_consent_status = getCookie('complianz_consent_status');
  //
  // 			  	//console.dir(complianz_consent_status);
  //
  // 			  	if(moocho_cookie_value) {
  // 			  		var show_moochopromo = false;
  // 			  		$('#moocho-container').addClass( "hidden" );
  // 			  	}
  //
  // 			  	// if(complianz_consent_status  == null) {
  // 			  	// 	var show_moochopromo = false;
  // 			  	// 	$('#moocho-container').addClass( "hidden" );
  // 			  	// }
  //
  // 			  	if(show_moochopromo) {
  //
  //
  // 			  		//first hide everything and clear queue
  //
  // 			  		// $('#moocho-container').clearQueue();
  // 			  		// $('#moocho-promo').clearQueue();
  //
  // 				  	// $('#moocho-promo').removeClass( "jello-horizontal" );
  // 				  	$('#moocho-container').removeClass( "hidden" );
  // 				  	  $('#moocho-container').removeClass( "slide-in-bottom" );
  // 				  	   $('#moocho-container').removeClass( "slide-out-bottom" );
  //
  //
  // 				  	  	$('#moocho-container').delay(250).queueAddClass('slide-in-bottom');
  // 				  		//$('#moocho-promo').delay(0).queueAddClass('jello-horizontal');
  //
  //
  //
  //
  // 				  	// 	$( "#moocho-container" ).hover(
  // 							//   function() {
  // 							//   	  $('#moocho-promo').removeClass( "jello-horizontal" );
  // 							//     $('#moocho-promo').delay(150).queueAddClass( "jello-horizontal" );
  // 							//      $('#moocho-promo').delay(1450).removeClass( "jello-horizontal" );
  // 							//   }, function() {
  // 							//    // $('#moocho-promo').removeClass( "jello-horizontal" );
  // 							//   }
  // 							// );
  //
  // 			  	}
  //
  // 			  		//close out moocho
  // 			  		$('#moocho-container .circle-button').click(function( event ) {
  // 			  				setCookie('moocho_cookie_new_9','closed',1);
  //
  //
  // 		        			event.preventDefault();
  // 		        			 $('#moocho-container').addClass( "slide-out-bottom" ).removeClass("slide-in-bottom");
  //
  //
  // 					  });
  // 			  	};
  //
  // };
  
  
  // var moochoPromoHide = function(actions) {
  // 	 var $moocho_container = $('#moocho-container');
  // 	  var $moochoIsHidden = $('#moocho-container').hasClass('hidden');
  // 	 // var $moochDisplay = $('#moocho-container').css('display');
  // 			//console.dir('try to hide-moocho:' + $moochoIsHidden);
  // 			  if ($moocho_container.length && ! $moochoIsHidden) {
  // 			  //	console.dir('hiding-moocho:');
  // 			  	//   console.dir('moochDisplay:' + $moochDisplay);
  // 	 				// console.dir('moochoIsOpen:' + $moochoIsOpen);
  // 	 			//	console.dir(actions);
  //
  //
  // 			  	//console.dir('hide')
  // 			  		// 	$('#moocho-container').clearQueue();
  // 			  		// $('#moocho-promo').clearQueue();
  //
  // 			  	// var moocho_cookie_value = getCookie('moocho_cookie_new_3');
  // 			  	// var show_moochopromo = true;
  // 			  	// if(moocho_cookie_value) {
  // 			  	// 	var show_moochopromo = false;
  // 			  	// }
  // 			  		// if(show_moochopromo) {
  // 			  		if(actions == 'slide-out-hidden') {
  // 			  			$('#moocho-container').removeClass( "slide-out-bottom" ).removeClass("slide-in-bottom");
  // 			  			 $('#moocho-container').addClass( "hidden" );
  // 			  		}else{
  // 			  			 $('#moocho-container').addClass( "slide-out-bottom" ).removeClass("slide-in-bottom");
  // 			  		}
  //
  //
  //
  // 					 // $('#moocho-promo').removeClass( "jello-horizontal" );
  // 					//}
  // 					}
  // }
  
  //homepage slider functions
  
  var homesliders = function() {
  
  
			  //content slider(s)
  
			  if( $('#home-content-slider').length) {
				  var $home_content_slider =  $('#home-content-slider.flexslider').flickity({
							// options
						  lazyLoad: true,
						   setGallerySize: false,
						   prevNextButtons: false,
						   dragThreshold: 10,
					  autoPlay: 7000,
					   wrapAround: true,
  
					  pauseAutoPlayOnHover: false
  
						  });
  
				  $home_content_slider.flickity('stopPlayer');
				  window.home_content_slider = $home_content_slider;
  
					$('#home-content-slider.flexslider a').hover(
					  function() {
						   $home_content_slider.flickity('pausePlayer');
						}, function() {
						   $home_content_slider.flickity('unpausePlayer');
						}
					  );
  
				  // var flkty_home_content_slider = $home_content_slider.data('flickity');
				  // var currentIndex_content_slider = flkty_home_content_slider.selectedIndex;
				  // time = 1700;
  
				  $home_content_slider.on( 'change.flickity', function( event, index ) {
				   var flkty_home_content_slider = $home_content_slider.data('flickity');
				   var currentIndex_content_slider = flkty_home_content_slider.selectedIndex;
				   time = 400;
				  animateSlideContent_home_content_slider(flkty_home_content_slider,time);
  
  
				  });
			  }
  
			  if( $('#home-content-slider-left').length) {
				  var $home_content_slider_left =  $('#home-content-slider-left.flexslider').flickity({
							// options
						  lazyLoad: true,
						   setGallerySize: false,
						   prevNextButtons: false,
						   dragThreshold: 10,
					  autoPlay: 7000,
					  wrapAround: true,
					  pauseAutoPlayOnHover: false
  
						  });
  
  
				  $home_content_slider_left.flickity('stopPlayer');
				  window.home_content_slider_left = $home_content_slider_left;
  
  
				  //pause on hover
				  $('#home-content-slider-left.flexslider a').hover(
					  function() {
						   $home_content_slider_left.flickity('pausePlayer');
						}, function() {
						   $home_content_slider_left.flickity('unpausePlayer');
						}
					  );
  
				  // var flkty_home_content_slider = $home_content_slider.data('flickity');
				  // var currentIndex_content_slider = flkty_home_content_slider.selectedIndex;
				  // time = 1700;
  
				  $home_content_slider_left.on( 'change.flickity', function( event, index ) {
				   var flkty_home_content_slider_left = $home_content_slider_left.data('flickity');
				   var currentIndex_content_slider_left = flkty_home_content_slider_left.selectedIndex;
				   time = 400;
				  animateSlideContent_home_content_slider(flkty_home_content_slider_left,time);
  
  
				  });
  
			  }
			   //end  content sliders
  
  
  
			   //homepage content slider center
  
  
			  var $home_content_slider_center =  $('#home-content-slider-center.flexslider').flickity({
						// options
					  lazyLoad: true,
					   setGallerySize: false,
					   prevNextButtons: false,
					   dragThreshold: 10,
					  autoPlay: 5000,
					  wrapAround: true,
					  pauseAutoPlayOnHover: false
  
					  });
  
  
				  $home_content_slider_center.flickity('stopPlayer');
				  window.home_content_slider_center = $home_content_slider_center;
  
				  //pause on hover
				  $('#home-content-slider-center.flexslider a').hover(
					  function() {
						   $home_content_slider_center.flickity('pausePlayer');
						}, function() {
						   $home_content_slider_center.flickity('unpausePlayer');
						}
					  );
  
			  $home_content_slider_center.on( 'change.flickity', function( event, index ) {
			   var flkty_home_content_slider_center = $home_content_slider_center.data('flickity');
			   var currentIndex_content_slider_center = flkty_home_content_slider_center.selectedIndex;
			   time = 400;
			  animateSlideContent_home_content_slider(flkty_home_content_slider_center,time);
  
  
			  });
  
			   //end homepage content slider
  
  
				//  slider center image 2
  
  
			  var $home_content_slider_center_2 =  $('#home-content-slider-center-2.flexslider').flickity({
						// options
					  lazyLoad: true,
					   setGallerySize: false,
					   prevNextButtons: false,
					   dragThreshold: 10,
					  autoPlay: 5000,
					  wrapAround: true,
					  pauseAutoPlayOnHover: false
  
					  });
  
  
				  $home_content_slider_center_2.flickity('stopPlayer');
				  window.home_content_slider_center_2 = $home_content_slider_center_2;
  
				  //pause on hover
				  $('#home-content-slider-center-2.flexslider a').hover(
					  function() {
						   $home_content_slider_center_2.flickity('pausePlayer');
						}, function() {
						   $home_content_slider_center_2.flickity('unpausePlayer');
						}
					  );
  
			  $home_content_slider_center_2.on( 'change.flickity', function( event, index ) {
			   var flkty_home_content_slider_center_2 = $home_content_slider_center_2.data('flickity');
			   var currentIndex_content_slider_center_2 = flkty_home_content_slider_center_2.selectedIndex;
			   time = 400;
			  animateSlideContent_home_content_slider(flkty_home_content_slider_center_2,time);
  
  
			  });
  
			   //end homepage content slider
  
  
				//  slider center image 1
  
  
			  var $home_content_slider_center_1 =  $('#home-content-slider-center-1.flexslider').flickity({
						// options
					  lazyLoad: true,
					   setGallerySize: false,
					   prevNextButtons: false,
					   dragThreshold: 10,
					  autoPlay: 5000,
					  wrapAround: true,
					  pauseAutoPlayOnHover: false
  
					  });
  
  
				  $home_content_slider_center_1.flickity('stopPlayer');
				  window.home_content_slider_center_1 = $home_content_slider_center_1;
  
				  //pause on hover
				  $('#home-content-slider-center-1.flexslider a').hover(
					  function() {
						   $home_content_slider_center_1.flickity('pausePlayer');
						}, function() {
						   $home_content_slider_center_1.flickity('unpausePlayer');
						}
					  );
  
			  $home_content_slider_center_1.on( 'change.flickity', function( event, index ) {
			   var flkty_home_content_slider_center_1 = $home_content_slider_center_1.data('flickity');
			   var currentIndex_content_slider_center_1 = flkty_home_content_slider_center_1.selectedIndex;
			   time = 400;
			  animateSlideContent_home_content_slider(flkty_home_content_slider_center_1,time);
  
  
			  });
  
			   //end homepage content slider
  
  
  
			   //mobile only slider on homepage
  
				   var $home_mobile_only_slider =  $('#mobile-only-slider-home').flickity({
						// options
					  lazyLoad: true,
					   setGallerySize: false,
					   prevNextButtons: false,
					   watchCSS: true,
					   dragThreshold: 10,
					  autoPlay: 5000,
					  wrapAround: true,
					  pauseAutoPlayOnHover: false
  
					  });
  
				   $home_mobile_only_slider.flickity('stopPlayer');
				  window.home_mobile_only_slider = $home_mobile_only_slider;
  
				   $home_mobile_only_slider.on( 'change.flickity', function( event, index ) {
			   var home_mobile_only_center_var = $home_mobile_only_slider.data('flickity');
			   var currentIndex_home_mobile_only_center_var = home_mobile_only_center_var.selectedIndex;
			   time = 400;
			   animateSlideContent_home_content_slider(home_mobile_only_slider,time);
  
  
			  });
			   //end mobile only homepage slider
  
  
  
			  //homepage top slider
  
			  var $home_slider = $('#home-slider');
			  if ($home_slider.length) {
  
				  $home_slider.on('ready.flickity', function(event, index) {
					  $('#slider-placeholder').remove();
				  });
  
				  $home_slider.flickity({
					  // options
					  bgLazyLoad: true,
					  prevNextButtons: false,
					  setGallerySize: false,
					  dragThreshold: 10,
					  autoPlay: 5000,
					  wrapAround: true,
					  pauseAutoPlayOnHover: false
  
				  });
  
				  //add extra time to first slide
				  $home_slider.flickity('stopPlayer');
  
				  if(! isMobileNav()) {
					  setTimeout(function() {
						  $home_slider.flickity('playPlayer');
					  }, 1000);
  
					   //pause on hover
					  $('#home-slider a').hover(
					  function() {
						   $home_slider.flickity('pausePlayer');
						}, function() {
						   $home_slider.flickity('unpausePlayer');
						}
					  );
				  }
  
  
  
				  var flkty_home_slider = $home_slider.data('flickity');
				  var currentIndex = flkty_home_slider.selectedIndex;
				  time = 1900;
  
				  //var hasMobileNav = $('.navbar-toggle').css('display');
				  if (isMobileNav()) {
					  time = 1200;
				  }
  
				  animateSlideContent(flkty_home_slider, time);
  
				  $home_slider.on('change.flickity', function(event, index) {
  
					  var flkty_home_slider = $(this).data('flickity');
					  var currentIndex = index;
					  // console.dir(flkty_home_slider);
  
					  time = 400;
  
  
					  animateSlideContent(flkty_home_slider, time);
				  });
  
  
				  $('#home-slider').addClass('fadeIn');
  
  
  
			  } //end homeslider
  
				  //prod category slider
				  var $productsliderhome = $('.product-slider-home');
  
				  if ($productsliderhome.length) {
				var $slider = $('.product-slider-home')
  
						   .on('init', function(slick) {
							  //$('.product-slider-home').fadeTo(1);
							   $('.product-slider-home').css('visibility','visible').hide().fadeIn();
  
  
						  })
  
  
						  .slick({
							  dots: false,
							  infinite: false,
							  speed: 400,
							  slidesToShow: 4,
							  slidesToScroll: 1,
							  lazyLoad: true,
  
							  easing: 'easeInOutBack',
							  useTransform: true,
							  dots: false,
							  responsive: [
							  {
							  breakpoint: 1024,
							  settings: {
							  slidesToShow: 3
  
							  }
							  },
							  {
							  breakpoint: 768,
							  settings: {
							  slidesToShow: 2
							  }
							  },
							  {
							  breakpoint: 520,
							  settings: {
							  slidesToShow: 1
							  }
							  }
  
							  ]
  
						  })
  
						 }
						 //end prod cat slider
		  }; //end homesliders
  
  var isMobileNav = function() {
	   navbar_on = $('.navbar-toggle').css('display');
	  if (navbar_on == 'block') {
		 return true;
	 }else{
			 return false;
	  }
  }
  
  
  var setupHeadroom = function(mql) {
  
	  if(! $('html').hasClass('fp-enabled')) {
			if(mql.matches) {
				//console.dir($("nav.navbar"));
			  $("nav.navbar").headroom();
  
			  $("nav.navbar").removeClass('headroom--unpinned');
			  //console.dir('setupHeadroom');
			}
			else {
				if($('nav.headroom--top').length || $('nav.headroom').length) {
				  $("nav.navbar").headroom("destroy");
				   //console.dir('destroy');
			   }
			}
	  }
  }
  
  
  
  
  var useHeadroomJS = function(direction) {
  
  
	   if(isMobileNav() && $('html').hasClass('fp-enabled')) {
			  if(direction == 'down') {
				  $('nav.navbar').addClass("headroom--unpinned");
			  }else if(direction == 'up') {
				  $('nav.navbar').removeClass("headroom--unpinned");
			  }
	   }
  }
  
  
  var scrollNav = function() {
  
			  var display = $(".navbar-toggle").css("display");
  
  
  
			  if($(".navbar-default").hasClass("dropdown-open")){
			//show scrollbar if window height is less than height of ul.products
			  var navheight = 760;
			  var windowheight = $(window).height();
			  var scrollheight = windowheight - 80;
  //            console.log(windowheight);
  //            console.log('nav: '+navheight);
			  if ((navheight > windowheight) && display != "block"){
				 // $('.dropdown-menu.products').css('max-height',scrollheight+'px');
				  $('.dropdown-menu.products > .divider').hide();
			  }else{
				   $('.dropdown-menu.products').css('max-height','none');
				  $('.dropdown-menu.products > .divider').show();
				  if (display == "block") {
					  // mobile nav view:
					   $('.dropdown-menu.products > .divider').hide();
  
				  }
  
			  }
		  }
		  };
  
  
		  //change body color based on #section0 class
		  var bodyColor = function() {
			   if($('#section0').length){
  
					var classList = "bodycolor-green, bodycolor-blue, bodycolor-orange, bodycolor-limegreen, bodycolor-blue-green, bodycolor-brown, bodycolor-purple, bodycolor-red";
  
					$('body').removeClass(classList);
					var top_section_classes = $('#section0').attr("class").split(/\s+/);
					// find all strings in array containing 'thi'
					  var index, value, result;
						  for (index = 0; index < top_section_classes.length; ++index) {
							  value = top_section_classes[index];
							  if (value.substring(0, 10) === "bodycolor-") {
								  // You've found it, the full text is in `value`.
								  // So you might grab it and break the loop, although
								  // really what you do having found it depends on
								  // what you need.
								  bodycolor = value;
								//   console.dir('adding:' + bodycolor);
									  $('body').addClass(bodycolor);
								  break;
							  }
						  }
					//var bodycolor = top_section_classes.find(a =>a.includes("bodycolor-"));
					//add body color class to body
					// if(typeof bodycolor !== 'undefined'){
					//   //hmm, not working when loading via barba
					//   console.dir('adding:' + bodycolor);
					//   $('body').addClass(bodycolor);
					// }
				  }
		  }
  
  // Window Scroll Functions
		  var throttle = function() {
  
			  var throttleTimeOut = 150; //milliseconds before triggering function again
  
			  // Window Scroll functions
			  $(window).on('scroll', _throttle(function(e){
				  /* do your normal scroll stuff here, but it'll be
				   * more-reasonably controlled, so as to not peg
				   * the host machine's processor */
  
  
				  if(! hazfullpage) {
					  //only run the condensed nav function here if not fullpage
						 updateNav();
					 }
  
			  }, throttleTimeOut));
  
			  // Window Resize Functions
			   if( $('#search-recipes').length ) {
					  var the_input = $('#search-recipes');
					  var desktopSearchPlaceholder = the_input.attr("placeholder");
  
			   }
  
			  onResize(desktopSearchPlaceholder);
  
  
			  $(window).on('resize', _throttle(function(){
				  /* do your normal resize stuff here, but it'll be
				   * more-reasonably controlled, so as to not peg
				   * the host machine's processor */
					  onResize(isMobileNav());
					  onResize(useHeadroomJS());
					   onResize(scrollNav());
					  onResize(updateNav());
					   onResize(desktopSearchPlaceholder);
  
			  }, throttleTimeOut));
  
		  };
  
  
  
  
		  var closeNav = function() {
			  //close main desktop nav
			   if ($('#navbar .dropdown').find('.dropdown-menu').is(":visible")){
  
					  $('#navbar .dropdown.open .dropdown-toggle').dropdown('toggle');
					}
  
			  //close mobile
			   $('#navbar').removeClass("opened");
  
			   $('#navbar').removeClass("in");
				   $(".navbar-default").removeClass("dropdown-open");
  
		  }
  
		  var updateLoadingImage = function() {
			preloaderImgs = $('#status img');
			preloaderImgs.removeClass("show");
			
			// Show random image - the existing CSS handles positioning and sizing
			var imageToShow = $(preloaderImgs[Math.floor(Math.random()*preloaderImgs.length)]);
			imageToShow.addClass('show');
		}
  
  
		  var trotPage = function() {
			  var joinlink = $('a[href*="#join"]');
			  joinlink.click(function( event ) {
				   fullpage_api.moveTo('join');
			  });
		  }
  
  
		  var updateNav = function() {
  
			   // var display = $("#close-mobile-nav").css("display");
				  //    if (display == "block") {
				  //      $(".navbar-collapse").collapse('hide');
				  //     }
  
			 // var display = $(".navbar-toggle").css("display");
  
	   //       if( display == "block"  && $('html').hasClass('fp-enabled') ){
	   //       	//mobile, move nav inside fullpage.js container so it isn't fixed
  
	   //       	$("#header").prependTo("#fullpage");
  
	   //      // 	$.fn.fullpage.reBuild();
  
	   //       }else{
	   //       	//destop, move nav back outside fullpage.js container
	   //       			$("#header").prependTo("div.body");
	   //       		//	$.fn.fullpage.reBuild();
	   //       }
  
  
  
  
			 closeNav();
  
  
  
			 if(! hazfullpage) {
  
				  if ($(window).scrollTop() > 20) {
					  $('.navbar-fixed-top').addClass("condensed");
  
				  } else {
					  $('.navbar-fixed-top').removeClass("condensed");
				  }
  
			  } else {
  
						 $('.navbar-fixed-top').removeClass("condensed");
			  //	navScroll();
				  // var fullpage_section_id = fullpage_api.getActiveSection().index;
				  // console.dir(fullpage_api.getActiveSection());
				  // if (fullpage_section_id > 0) {
				  // 	$('.navbar-fixed-top').addClass("condensed");
  
				  // } else {
				  // 	$('.navbar-fixed-top').removeClass("condensed");
				  // }
			  }
		  };
  
  
		  var onResize = function(desktopSearchPlaceholder) {
  
			  var width = $(window).width();
			  var ratio = width/1160;
			  if (ratio > 1) ratio = 1;
			  $(".dropdown-menu.products .inner").css("transform", "scale("+ratio+")");
  
			  if (width < 768) {
  
				  if( $('#search-recipes').length ) {
					  var the_input = $('#search-recipes');
					  var the_placeholder = the_input.attr("placeholder");
					  if(the_placeholder.length > 12) {
						  the_input.attr("placeholder", "Search here");
					  }
				  }
  
				  $(".grid-block .ratio-height").each(function() {
					  if (!$(this).hasClass("mobile-auto-height")) {
						  var height = $(this).height();
						  //console.log("height: "+height);
						  var content = $(this).find(".absolute-centered");
						  if (content.length == 1) {
							  var contentHeight = content.height();
							  //console.log("contentHeight: "+contentHeight);
							  var margin = (height-contentHeight)*.5;
							  //console.log("margin: "+margin);
							  if (margin < 20) $(this).addClass("mobile-auto-height");
						  }
  
					  }
				  });
			  }else{
				   if( $('#search-recipes').length ) {
					  var the_input = $('#search-recipes');
					  var the_placeholder = the_input.attr("placeholder");
  
					  if(the_placeholder.length < 12) {
  
						  the_input.attr("placeholder", desktopSearchPlaceholder);
					  }
				  }
			  }
  
		  };
  
  
  
  
  (function($) {
  
  
  // 	//newsletter pop link click
  
  // $('#newsletter_link').on('click',function (e) {
  // 	console.dir('CLICKED');
  // 	e.preventDefault();
  
  // 	var target = this.hash; 
  // 	var $target = $(target);
  // 	if ($target.length < 1) return;
  
  // 	$('html, body').stop().animate({
  // 		'scrollTop': $target.offset().top  - 160
  // 	}, 400, 'swing', function () {
  // 		window.location.hash = target;
  // 	});
  // });
  
	  //'use strict';
  
	  var SiteApp = {
  
		  // Initialize the functions
		  init: function() {
  
			  SiteApp.Mobiledetect();
			  //SiteApp.Smoothscroll();
			  //SiteApp.Throttle();
			  SiteApp.Preloader();
			  // SiteApp.Slider();
			  // 					$('#home-slider').addClass('fadeIn');
			  SiteApp.Nav();
  
			  //woocommerce? then no barba -- barba loads page via ajax, which messes up woocommerce
			  var useBarba = true;
			  var bodyclasses = $('body').attr("class").split(/\s+/);
				 var pathname = window.location.pathname;
			 //	console.dir(pathname);
			  if($('body.woocommerce-page').length) {
					  useBarba = false;
					//  console.dir('no barba');
			  }
  
			  if($('body.page-template-campaign-no-nav, body.page-template-holiday-no-nav, body.page-template-food-services-new, body.page-template-creator, body.page-template-get_reviews, body.page-template-get_reviews_all_products').length) {
					  useBarba = false;
					  console.dir('no barba');
			  }
  
			  if(useBarba) {
  
				  SiteApp.barbaJS();
  
  
			  }
  
			  
  
  
			 // SiteApp.Retina();
			  //SiteApp.chezMarie();
			//  SiteApp.video();
  
			//  SiteApp.Fullpage();
  
			//careers slider
			 SiteApp.SliderTest();
			 SiteApp.CareersSlider();
			 SiteApp.ValuesSlider();
			 SiteApp.AboutSlider();
  
			  //SiteApp.Lightbox();
  
			  // Call this to show all animited items
			  // SiteApp.ShowAnimated();
		  },
  
  
		  Retina: function() {
			 // $('img.retina').dense({
			 //   'ping'      : false,
			 //   'dimension' : 'preserve'
			 //  });
		  },
  
  
		  // Mobile Device Detection
		  Mobiledetect: function() {
  
			  var ismobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
  
			  if(ismobile == true){
				  $('body').addClass('mobile');
			  } else {
				  $('body').addClass('no-touch');
			  }
  
		  },
  
  
  
  
  
		  // Page Loading Progress
		  Preloader: function() {
  
			  // Prevent page scrolling during preloader
			  $('html, body').css('overflow', 'hidden');
			  
			  // Store current scroll position
			  var scrollPos = $(window).scrollTop();
			  
			  // Restore random image selection
			  updateLoadingImage();
  
			  // Safety timeout - ensure preloader doesn't show for more than 5 seconds
			  setTimeout(function() {
				  if ($('#preloader').is(':visible')) {
					  useFullPage();
					  $('#preloader').fadeOut(300);
					  // Restore scroll
					  $('html, body').css('overflow', '');
					  $(window).scrollTop(scrollPos);
				  }
			  }, 5000);
  
			  // Original slower timing with random images
			  $('#preloader #status').delay(1500).fadeOut(300, function() {

				  useFullPage();

				   $('#preloader').delay(350).fadeOut(300, function(){

					//$('body').delay(350).css({'overflow':'visible'});
					
					// Restore scroll and ensure page is at top
					$('html, body').css('overflow', '');
					$(window).scrollTop(0);

				 }); // will fade out the white DIV that covers the website.

				 });
  
		  },
  
  
  
  
  
  
		  // Slider
  
	  SliderTest: function() {
  
  
	var $vidCarousel = $('.carousel-video');
  
	if ($vidCarousel.length) {
  
  // bind event listener first
  $vidCarousel.on( 'ready.flickity', function() {
	console.log('Flickity ready');
  
  });
  
	  $vidCarousel.flickity({
			 contain: true,
			 pageDots: false,
			 prevNextButtons: false,
			 imagesLoaded: true
			 });
  
  
  //get nav carousel and move first slide to endif
  // init Flickity with jQuery
  var $the_carousel_nav_obj = $('.carousel-nav');
  if ($the_carousel_nav_obj.length) {
  
		var $carouselNav = $('.carousel-nav').flickity();
		// get instance
		var flkty = $carouselNav.data('flickity');
		var $cells = $carouselNav.find('.carousel-cell');
		var $first_cell = $cells[0];
		//console.dir($cells[0]);
		// remove first 3 cells
		 // $carouselNav.flickity( 'selectCell', 1 );
		  // $carouselNav.flickity( 'remove', $first_cell);
		  // $carouselNav.flickity( 'append', $first_cell);
	  }
  
			   // jQuery
   $( window ).on( 'load', function() {
	 $vidCarousel.flickity('resize');
	 //console.dir('flickity resized');
   });
  
  
			 $vidCarousel.on( 'settle.flickity', function() {
			   console.log('settle');
				 newTarg = $(".carousel-video .carousel-cell.flex-video").not('.is-selected');
				// console.dir(newTarg);
				 $(newTarg).find('iframe').each(function() {
					   var src= $(this).attr('src');
					//   console.dir(src);
					  // console.dir($(this));
					   $(this).attr('src',src);
				 });
				 console.log('slide changes');
  
  
			 });
		   }
  
		   },
  
	  ValuesSlider: function() {
  
		  var $carouselValuesSlider = $('.values-block .carousel');
  
			  if ($carouselValuesSlider.length) {
  
		  // jQuery
		  $( window ).on( 'load', function() {
		  $carouselValuesSlider.flickity('resize');
			});
  
			$carouselValuesSlider.flickity({
				   contain: true,
				   pageDots: false,
				   prevNextButtons: false,
				   imagesLoaded: true,
				   draggable: true
				   });
				 }
  
	  },
  
  
	AboutSlider: function() {
  
		  var $carouselAboutSlider = $('.about-slider');
  
			  if ($carouselAboutSlider.length) {
  
		  // jQuery
		  $( window ).on( 'load', function() {
		  $carouselAboutSlider.flickity('resize');
			});
  
			$carouselAboutSlider.flickity({
				   contain: false,
				   pageDots: true,
				   prevNextButtons: false,
				   imagesLoaded: true,
				   draggable: true,
				   autoPlay: 3500,
  pauseAutoPlayOnHover: true
				   });
				 }
  
	  },
  
  
	  CareersSlider: function() {
		var $careersPage = $('.page-template-careers-page #section0');
  
		animateFade($careersPage, 3200, 250);
  
	  var $carouselCareersSlider = $('.careers-slider .carousel');
  
	  if ($carouselCareersSlider.length) {
  
  
  
	  // jQuery
	  $( window ).on( 'load', function() {
	  $carouselCareersSlider.flickity('resize');
	  //console.dir('flickity resized');
	  var $maxheightNav = $('.careers-slider .carousel .flickity-viewport').height();
	   $('.careers-slider .carousel-nav-careers').css('max-height', $maxheightNav - 100 + 'px')
	  });
  
	  // // bind event listener first
	  //     $( window ).on( 'load', function() {
	  // $carouselCareersSlider.on( 'ready.flickity', function() {
	  //   console.log('Flickity ready');
	  //
	  // });
  
	  $carouselCareersSlider.flickity({
			 contain: true,
			 pageDots: false,
			 prevNextButtons: false,
			 imagesLoaded: true,
			 draggable: false
			 });
  
  
  var $carouselNav = $('.careers-slider .carousel-nav-careers');
  var $carouselNavCells = $carouselNav.find('.carousel-cell');
  
  $carouselNav.on( 'click', '.carousel-cell', function( event ) {
	var index = $( event.currentTarget ).index();
	$carouselCareersSlider.flickity( 'select', index );
  });
  
  var flktyCareersSlider = $carouselCareersSlider.data('flickity');
  var navTop  = $carouselNav.position().top;
  var navCellHeight = $carouselNavCells.height();
  var navHeight = $carouselNav.height();
  
	$carouselCareersSlider.on( 'select.flickity', function() {
	  // set selected nav cell
	  $carouselNav.find('.is-nav-selected').removeClass('is-nav-selected');
	  var $selected = $carouselNavCells.eq( flktyCareersSlider.selectedIndex )
		.addClass('is-nav-selected');
	  // scroll nav
  
	  // var scrollY = $selected.position().top +  $carouselNav.scrollTop() - ( navHeight + navCellHeight ) / 2;
	  // $carouselNav.animate({
	  //   scrollTop: scrollY
	  // });
	  //   console.dir('scrollnav');
	  //     console.dir('scrollY:' + scrollY);
	  //       console.dir('$selected:' + $selected);
	  //         console.dir('navCellHeight:' + navCellHeight);
	  //         console.dir('$selected.position().top:' + $selected.position().top);
	  //           console.dir('carouselNavCells:' + $carouselNavCells.position().top);
	});
	}
  
		   },
  
		  // Lightbox Gallery
		  Lightbox: function() {
  
			  $('.imagepop').magnificPopup({type:'image'});
  
		  },
  
  
  
		  // Animation Effects
		  Animated: function() {
  
			  $('.animation, .animation-visible').each(function() {
  
				  var $element = $(this);
  
				  $element.waypoint(function() {
  
					  var delay = 0;
  
					  if ($element.attr('data-delay')) delay = parseInt($element.attr('data-delay'), 0);
					  if (!$element.hasClass('animated')) {
						  setTimeout(function() {
							  $element.addClass('animated ' + $element.attr('data-animation'));
						  }, delay);
					  }
					  delay = 0;
				  }, {
					  offset: '70%'
				  });
  
			  });
  
		  },
  
  
		  // Show All Animated Items
		  ShowAnimated: function() {
  
			  $('.animation, .animation-visible').each(function() {
				  $(this).addClass('animated');
			  });
  
		  },
  
		  Nav: function(){
  
  
  
			  $('.dropdown').on('show.bs.dropdown', function(e){
  
					  var addDisplayElement = e.relatedTarget.nextElementSibling;
					  $(addDisplayElement).addClass("opening");
				  $(".navbar-default").addClass("dropdown-open");
					   $('.dropdown-menu .animate').removeClass("slide-out-bottom");
				  $('.dropdown-menu .animate').delay(100).queueAddClass('slide-in-bottom');
  
				 scrollNav();
				// moochoPromoHide();
  
					var $this = $(this);
					var data_href = $(this).find('a').attr('data-href');
					if(data_href == '#products') {
  
						//moochoPromoShow('menu');
					}
  
			  });
  
  
  
			  $('.dropdown').on('hide.bs.dropdown', function(e){
  
				  $(".navbar-default").removeClass("dropdown-open");
				   $('.dropdown-menu .animate').removeClass("slide-in-bottom");
			   //	moochoPromoHide();
				 // $('.dropdown-menu img.animate').addClass("slide-out-bottom");
			  });
  
			  $('.dropdown').on('hidden.bs.dropdown', function(e){
  
				 setTimeout(function() {
  
				   $('.navbar-nav ul').removeClass("opening");
				  }, 300);
			  });
  
			  $('#navbar').on('show.bs.collapse', function () {
				  $(".navbar-default").addClass("dropdown-open");
				  $('#navbar').addClass("opened");
  
			  });
  
			  $('#navbar').on('hidden.bs.collapse', function (e) {
  
				   setTimeout(function() {
				   $('#navbar').removeClass("opened");
  
				  }, 300);
			  });
  
  
  
			  $('#navbar').on('shown.bs.collapse', function () {
				 // var height = $(window).height();
				  //height = height - 60; // minus height of header in mobile view.
				  //$(".navbar-collapse.collapse.in").height(height);
			  });
  
			  $('#navbar').on('hide.bs.collapse', function () {
				  //mobile nav called to close
				  $(".navbar-default").removeClass("dropdown-open");
  
			  });
  
			   $('#search-form .btn').on('click',function() {
				   SiteApp.toggleSearch();
				   //$('#search-form > div').toggleClass('search-open');
			   });
  
			   $('.search-cta, #search-form .close').on('click',function(e) {
				   e.preventDefault();
				   SiteApp.toggleSearch();
			   });
  
  
				  $('#search-form').submit(function( event ) {
					//alert( "Handler for .submit() called." );
  
					   //$('#search-form > div').addClass('search-open');
  
  
  
					  if($('#search-form input.s').val()){
						return;
					  }
  
					  event.preventDefault();
  
				  });
  
				  $(".fa-search.submit").on("click", function() {
					  $('#search-form').submit();
				  });
  
		  },
  
  
  
		  closeSearch: function() {
			  $(".search-wrapper .search-input").css("width", "0px");
  
				  $(".fa-search.submit").css("left", "-68px");
		  },
  
		  toggleSearch: function() {
			  // use this to detect mobile css layout:
			  var display = $(".navbar-toggle").css("display");
			  $('#search-form').toggleClass('search-open');
			  $('.navbar-default').toggleClass('search-open');
			   $('#search-form > div').toggleClass('search-open');
			   var input = $(".search-wrapper.search-open .search-input");
  
			   //dont hide on mobile
		   if (display !== "block") {
				   $('.navbar-right').hide();
				}
  
			   if (input.length == 1) {
				  // open
				  var width = $(".navbar-nav").width() + 50;
				  var iconOffset = 50;
  
				  if (display == "block") {
					  // mobile nav view:
					  width = $(window).width()-220;
					  iconOffset = 30;
				  } else {
  
				  }
				  $(".search-wrapper .search-input").width(width);
				  var left = -width - iconOffset;
				  $(".fa-search.submit").css("left", left+"px");
  
				  setTimeout(function() {
					  $(".search-wrapper.search-open .search-input").val("").focus();
				  }, 100);
  
				  /*
				  setTimeout(function() {
					  $("#search-form").bind("clickoutside focusout", SiteApp.toggleSearch);
				  }, 100);
				  */
			   } else {
				   // close
				  $(".search-wrapper .search-input").css("width", "0px");
				  //$("#search-form").unbind("clickoutside focusout", SiteApp.toggleSearch);
				  $(".fa-search.submit").css("left", "-68px");
				  $('.navbar-right').show();
			   }
		  },
  
  
  
		  chezMarie: function(){
  
			  var getUrlParameter = function getUrlParameter(sParam) {
			  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
					  sURLVariables = sPageURL.split('&'),
					  sParameterName,
					  i;
  
				  for (i = 0; i < sURLVariables.length; i++) {
					  sParameterName = sURLVariables[i].split('=');
  
					  if (sParameterName[0] === sParam) {
						  return sParameterName[1] === undefined ? true : sParameterName[1];
					  }
				  }
			  };
  
			  var chezVar = getUrlParameter('chez-marie');
			  if(chezVar){
				  //.load('http://tofurky.dev')
				   $('#chezMarieModal').modal('show').find('.modal-body');
  
			  }
  
		  },
  
		   video: function(){
			  var $vidElement = $('.has-video');
			  if ($vidElement.length){
  
				  //grab vid link
				  var $vidContainer = $vidElement.parent();
				  var $vidLink = $vidContainer.attr('href');
				  //create iframe
				  $('<iframe>', {
						 src: $vidLink,
						 id:  'myVid',
						 frameborder: 0,
						 scrolling: 'no'
						 }).appendTo($vidElement);
  
  
  
				  //fitvids
				   $('.has-video').fitVids();
  
  
  
				   //hide iframe
				  $('.fluid-width-video-wrapper').hide();
  
				  $vidElement.click(function( event ) {
  
					  event.preventDefault();
  
					  var $this = $(this);
  
					  if($this.data('clicked')) {
  
						 }
						  else {
							  $this.data('clicked', true);
							   //kill href
								$vidContainer.children().unwrap();
							  $vidElement.removeClass('desktop-ratio-50 ratio-135');
							  $vidElement.css("background-image","");
							  $('.fluid-width-video-wrapper').show();
							   $("#myVid")[0].src += "&autoplay=1";
						  }
				  });
  
  
			  }
  
		  },
  
  
		  barbaJS: function() {
			  //console.dir('using barba');
				  //this code loads content via ajax..no page reload
						  Barba.Pjax.start();
  
						  // Create a global variable to store the bodyClasses
						  var bodyClasses;
						  // Update body classes by replacing the barba.js internal function
						  // See: https://github.com/luruke/barba.js/issues/49#issuecomment-237966009
						  var originalFn = Barba.Pjax.Dom.parseResponse;
						  Barba.Pjax.Dom.parseResponse = function(response) {
							  // Because jQuery will strip <body> when parsing a HTML DOM, change
							  // <body> to <notbody>, then we can grab the classes assigned to it
							  // See: http://stackoverflow.com/a/14423412/4081305
							  response = response.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', response);
							  // Get the classes on the <notbody> element
							  bodyClasses = $(response).filter('notbody').attr('class');
							  // Call the original barba.js function
							  return originalFn.apply(Barba.Pjax.Dom, arguments);
						  };
  
  
  
						  //new page ready- init scripts
						  Barba.Dispatcher.on('transitionCompleted', function(currentStatus, oldStatus, container) {
							  // Re-init your scripts here.
							  //console.dir(currentStatus);
							  useFullPage();
							  throttle();
  
							  $('body').attr('class', bodyClasses)
							  bodyColor();
  
							  //console.dir('reinit scripts for barba'); 
							  if($('body.page-template-product').length) {
								  //console.dir('reinit scripts for barba on product page if needed here'); 
								  const target = document.getElementById("reviews");
								  const productId = target.getAttribute("data-product-id");
								  target.innerHTML = '';
								  target.innerHTML = '<div data-bv-show="reviews" data-bv-product-id="' + productId + '"></div>';
								  
								  
  
						  
							  
								   
							  } 
  
  
						  }); 
  
  
  
  
						  //page transition
						  var FadeTransition = Barba.BaseTransition.extend({
							  start: function() {
  
								  updateLoadingImage();
  
							   //  moochoPromoHide('slide-out-hidden');
								  /**
								   * This function is automatically called as soon the Transition starts
								   * this.newContainerLoading is a Promise for the loading of the new container
								   * (Barba.js also comes with an handy Promise polyfill!)
								   */
  
								  // As soon the loading is finished and the old page is faded out, let's fade the new page
								  Promise
									  .all([this.newContainerLoading, this.fadeOut()])
									  .then(this.fadeIn.bind(this));
							  },
  
							  fadeOut: function() {
								  /**
								   * this.oldContainer is the HTMLElement of the old Container
								   */
								  //remove nav on fade
								  // navAnimationReset();
  
								  //close mobile nav:
								  updateNav();
								  // var display = $("#close-mobile-nav").css("display");
								  // if (display == "block") {
								  //   $(".navbar-collapse").collapse('hide');
								  //  }
								  // $(".navbar-collapse").removeClass('in');
								  // $('.dropdown.open .dropdown-toggle').dropdown('toggle');
								  //show preloader
  
  
  
  
								  $('#preloader').fadeIn(300);
								  return $('#preloader #status').fadeIn(300).promise();
								  //  return $(this.oldContainer).animate({ opacity: 0 }).promise();
							  },
  
							  fadeIn: function() {
								  /**
								   * this.newContainer is the HTMLElement of the new Container
								   * At this stage newContainer is on the DOM (inside our #barba-container and with visibility: hidden)
								   * Please note, newContainer is available just after newContainerLoading is resolved!
								   */
  
								  // Safety timeout for Barba transitions
								  setTimeout(function() {
									  if ($('#preloader').is(':visible')) {
										  $('#preloader').fadeOut(300);
									  }
								  }, 5000);
  
								  $('#preloader #status').delay(200).fadeOut(300, function() {
  
  
  
									  $('#preloader').delay(250).fadeOut(300, function(){
  
										  //$('body').delay(350).css({'overflow':'visible'});
  
									  }); // will fade out the white DIV that covers the website.
  
								  });
  
								  var _this = this;
								  var $el = $(this.newContainer);
  
								  $(this.oldContainer).hide();
  
								  $el.css({
									  visibility: 'visible',
									  opacity: 1
								  });
  
								  // $el.animate({ opacity: 1 }, 300, function() {
								  /**
								   * Do not forget to call .done() as soon your transition is finished!
								   * .done() will automatically remove from the DOM the old Container
								   */
  
								  _this.done();
								  // });
							  }
						  });
  
						  /**
						   * Next step, you have to tell Barba to use the new Transition
						   */
  
						  Barba.Pjax.getTransition = function() {
							  /**
							   * Here you can use your own logic!
							   * For example you can use different Transition based on the current page or link...
							   */
  
							  return FadeTransition;
						  };
  
						  //link click--prevent barba from running on certain links
						  Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;
  
						  Barba.Pjax.preventCheck = function(evt, element) {
  
  
  
							  
							  //don't reload site on hash tag links...for pdp page
  
							  // additional (besides .no-barba) ignore links with these classes
							  // ab-item is for wp admin toolbar links
							  // if(element !== null && element !== '') {
							  var ignoreClasses = ['no-barbajs', 'woocommerce-loop-product__link', 'added_to_cart', 'cc-btn'];
							  for (var i = 0; i < ignoreClasses.length; i++) {
  
								  if (element) {
									  if (element.classList.contains(ignoreClasses[i])) {
										  return false;
									  }
								  } else {
									  return false;
								  }
							  }
  
							  // Prevent Barba.js from handling navigation to creator page and reviews pages
							  if (
								  element &&
								  element.getAttribute('href') &&
								  (element.getAttribute('href').indexOf('/creator-crew') > -1 || 
								   element.getAttribute('href').indexOf('/creator') > -1 ||
								   element.getAttribute('href').indexOf('/reviews') > -1 ||
								   element.getAttribute('href').indexOf('/product-reviews-all-products') > -1)
							  ) {
								  return false;
							  }
  
							  if (
								  element &&
								  element.getAttribute('href') &&
								  element.getAttribute('href').indexOf('#') > -1
							  ) {
								  return true;
							  } else {
								  return Barba.Pjax.originalPreventCheck(evt, element);
							  }
						  //}
						  } //end preventcheck
  
  
						  }
  
			  };
  
  
  
  
  
  
			  // Run the Main Function
			  $(function() {
				  SiteApp.init();
  
				  //onResize();
  
  
  
  
  
			  });
  
  
  
  
		  })(window.jQuery);
  